import React, { FC, PropsWithChildren } from 'react';

import useStyles from './buttonsContainer.styles';

const ButtonsContainer: FC<PropsWithChildren> = ({ children }) => {
  const { buttonsContainer } = useStyles();
  return <div className={buttonsContainer}>{children}</div>;
};

export default ButtonsContainer;
